


export interface ProductReviewResponse {
    pagination: Pagination;
    records: ProductsReview[];
}
 interface Pagination {
    total_records: number;
    total_pages: number;
    limit: number;
    page: number;
}

 export interface ProductsReview {
    id: string;
    product_id: string;
    product_variant_id: string;
    user_id: string;
    order_id: string;
    order_item_id: string;
    rating: number;
    title: string;
    message: string;
    helpful_count: string;
    status: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    product_review_galleries: ProductReviewGallery[];
    product_variant: ProductVariant;
}

 interface ProductReviewGallery {
    id: string;
    image_url: string;
    key: string;
}

 interface ProductVariant {
    id: string;
    product_id: string;
    sku: string;
    sale_price: number | null;
    regular_price: number;
    partner_sku: string;
    quantity_available: number;
    quantity_low: number;
    weight_unit: string | null;
    weight_value: number | null;
    produced_date: string | null;
    expiry_date: string | null;
    is_in_stock: boolean;
    model_number: string | null;
    dimension_length: number | null;
    dimension_width: number | null;
    dimension_height: number | null;
    default_thumbnail: string | null;
    num_sales: number;
    cached_review_count: number;
    cached_average_rating: number;
    cached_ratings_json: CachedRatingsJson;
    createdAt: string;
    updatedAt: string;
    product: Product;
    product_variant_gallery: ProductVariantGallery;
}

 interface CachedRatingsJson {
    [key: string]: number;
}

 interface Product {
    id: string;
    product_type: string;
    warranty_days: number;
    guarantee_days: number;
    category_id: string;
    brand_id: string;
    creator_id: string | null;
    is_refurbished: boolean;
    is_featured: boolean;
    status: string;
    category: Category;
    brand: Brand;
}

 interface Category {
    id: string;
    slug: string;
    translation: CategoryTranslation;
}

 interface CategoryTranslation {
    __key: string;
    name: string;
}

 interface Brand {
    id: string;
    slug: string;
    translation: BrandTranslation;
}

 interface BrandTranslation {
    __key: string;
    name: string;
}

 interface ProductVariantGallery {
    product_variant_id: string;
    image_thumbnail_url: string;
}